<!-- 年级、班级 级联选择器 -->
<template>
  <el-cascader
    :options="options"
    v-model="selectedOptions"
    @change="handleChange" />
</template>

<script>
import { querySchoolClasses } from '@/model/info-model'

export default {
  name: 'GradeClass',
  props: {
    orgId: {
      type: String,
      required: true
    },
    httpRequest: {
      type: Function,
      default () {
        return querySchoolClasses
      }
    },
    initSelected: {
      type: Boolean,
      default: false
    },
    classId: {
      type: String
    }
  },
  data () {
    return {
      gradeNames: ['小一', '小二', '小三', '小四', '小五', '小六', '初一', '初二', '初三', '高一', '高二', '高三'],
      options: [],
      selectedOptions: []
    }
  },
  watch: {
    initSelected (value) {
      if (!value) {
        this.selectedOptions = []
      }
    }
  },
  methods: {
    calcGradeName (gradeId) {
      let gradeName = ''
      try {
        gradeName = this.gradeNames[parseInt(gradeId) - 1]
      } catch (e) {
        console.log(e)
      }
      return gradeName
    },
    calcOptions (orgClassInfo) {
      let options = []
      let gradeIdsInOptions = []
      let currentClassId = this.classId

      let gradeLevels = [orgClassInfo.primary, orgClassInfo.junior, orgClassInfo.high]
      let classItem
      gradeLevels.forEach(grade => {
        grade.forEach(v => {
          if (gradeIdsInOptions.includes(v.gradeid)) {
            classItem = {
              // value: v.classid,
              value: v.classcode,
              label: v.classname
            }
            if (v.classid === currentClassId) {
              classItem.disabled = true
            }
            // 因为接口返回的数据是已经按年级、班级排序了, 所以直接在后面追加就可以了
            options[options.length - 1].children.push(classItem)
          } else {
            classItem = {
              // value: v.classid,
              value: v.classcode,
              label: v.classname
            }
            if (v.classid === currentClassId) {
              classItem.disabled = true
            }
            // 如果当前年级第一次出现
            options.push({
              value: v.gradeid,
              label: this.calcGradeName(v.gradeid),
              children: [classItem]
            })
            gradeIdsInOptions.push(v.gradeid)
          }
        })
      })
      return options
    },
    handleChange (value) {
      console.log(value)
      this.$emit('grade-class-change', value)
    }
  },
  created () {
    querySchoolClasses({ orgid: this.orgId }).then(res => {
      console.log(res)
      if (res.result === 'true') {
        this.options = this.calcOptions(res.data)
      } else {
        this.$message.error('查询班级失败！')
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/GradeClass.vue